import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Checkbox, FormControlLabel, IconButton, TextField } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from "examples/Footer";
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function AddPermissions() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const [rules, setRules] = useState([]);
    const navigate = useNavigate();

    const handleAddRule = () => {
        setRules([...rules, { name: '', access: false }]);
    };

    const handleRuleChange = (index, field, value) => {
        const updatedRules = rules.map((rule, i) =>
            i === index ? { ...rule, [field]: value } : rule
        );
        setRules(updatedRules);
    };

    const handleRemoveRule = (index) => {
        setRules(rules.filter((_, i) => i !== index));
    };

    const onSubmit = async (values, { resetForm }) => {
        try {
            const payload = { ...values, rules };
            const response = await axios.post(`${apiUrl}auth-service/permission`, payload, {
                headers: { 'Authorization': `Bearer ${bearerToken}` },
            });
            if (response.data?.success && response.data?.data) {
                toast.info(response.data.message || 'Permission created successfully');
            } else {
                throw new Error("Failed to create permission");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
        } finally {
            resetForm();
            setTimeout(() => {
                navigate(-1);
            }, 1500);
        }
    };

    const newPermission = useFormik({
        initialValues: {
            name: '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Required'),
        }),
        onSubmit,
    });


    return (
        <DashboardLayout><DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <form onSubmit={newPermission.handleSubmit}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                    display="flex"
                                    justifyContent="space-between"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Add New Permission
                                    </MDTypography>
                                </MDBox>
                                <MDBox p={2}>
                                    <MDBox p={1}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            id="name"
                                            label="Name"
                                            name="name"
                                            value={newPermission.values.name}
                                            onChange={newPermission.handleChange}
                                            onBlur={newPermission.handleBlur}
                                            error={newPermission.touched.name && Boolean(newPermission.errors.name)}
                                            helperText={newPermission.touched.name && newPermission.errors.name}
                                        />
                                    </MDBox>
                                    <MDBox p={1}>
                                        <MDTypography variant="h6">Rules</MDTypography>
                                        {rules.map((rule, index) => (
                                            <MDBox key={index} display="flex" alignItems="center" mb={2}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Rule Name"
                                                    value={rule.name}
                                                    onChange={(e) =>
                                                        handleRuleChange(index, 'name', e.target.value)
                                                    }
                                                    style={{ marginRight: '10px' }}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={rule.access}
                                                            onChange={(e) =>
                                                                handleRuleChange(index, 'access', e.target.checked)
                                                            }
                                                        />
                                                    }
                                                    label="Access"
                                                />
                                                <IconButton onClick={() => handleRemoveRule(index)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </MDBox>
                                        ))}
                                        <MDButton variant="outlined" color="info" onClick={handleAddRule}>
                                            Add Rule
                                        </MDButton>
                                    </MDBox>
                                    <MDBox p={1}>
                                        <MDButton color="info" type="submit">
                                            Save
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </form>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </DashboardLayout>
    )
}